export enum EditNewsTabType {
    view = "view",
    edit = "edit",
}
